module.exports = __webpack_public_path__ + "img/liste-de-choses-a-faire.1b994144.png";